import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import LazyLoad from "react-lazyload";
const SchoolFeeStructure = () => {
  useEffect(() => {
    document.title = "School Fee Structure - St. Francis Xavier School";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>CBSE Public Disclosure</li>
          <li>School Fee Structure</li>
        </ul>
      </div>
      <section className="innerbody">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="col-lg-12 mand_dis_sec">
                <LazyLoad>
                  <iframe
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/pdf/FEE-STRUCTURE-OF-SCHOOL.pdf"
                    className="w-100"
                    style={{ height: "600px", border: "none" }}
                    title="Fee Structure PDF"
                  />
                </LazyLoad>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default SchoolFeeStructure;
